<template>
	<v-card class="banner" color="contained">
		<div class="rotate-container">
			<div class="rotate">
				<h2>Voicebot powered by</h2>
				<img
					v-for="(logo, index) in logos"
					:key="index"
					:src="logo.src"
					:alt="logo.alt"
					class="banner-logo"
					:style="{ height: logo.height }"
				/>
			</div>
		</div>
	</v-card>
</template>

<script setup lang="ts">
import { ref } from "vue";

const logos = ref([
	{
		src: "https://assets.livereader.com/asset/YSvQcUkqj96bnFer.png",
		alt: "Alternis_Logo",
		height: "90%",
	},
]);
</script>

<style scoped lang="scss">
.banner {
	width: 100vw;
	height: 100px;
	overflow: hidden;
}

.rotate-container {
	display: flex;
	width: 100%;
}

.rotate {
	height: 100px;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-evenly;
}

.banner-logo {
	width: auto;
	flex-shrink: 0;
}
</style>
